import * as React from 'react';
import { resultPicker } from '../../../../../utils/PPA';
import { fm } from 'Components/FormatMessage';

const PPADiagnosticCriteriaHistory = ({ d }: IOwnProps): React.JSX.Element => {
  const sections: Array<'nonfluentVariantPPA' | 'semanticDementia' | 'logopenicProgressiveAphasia'> = [
    'nonfluentVariantPPA',
    'semanticDementia',
    'logopenicProgressiveAphasia',
  ];

  const imagingKeyMap: Record<(typeof sections)[number], string> = {
    nonfluentVariantPPA: 'criteriaForDiagnosisSupportedByImagingStudiesForNfvPPAFulfilled',
    semanticDementia: 'criteriaForDiagnosisSupportedByImagingStudiesForSemanticDementiaFulfilled',
    logopenicProgressiveAphasia: 'criteriaForDiagnosisSupportedByImagingStudiesForLogopenicProgressiveAphasiaFulfilled',
  };

  const neuropathologicalKeyMap: Record<(typeof sections)[number], string> = {
    nonfluentVariantPPA: 'criteriaForNeuropathologicallyConfirmedDiagnosisForNfvPPAFulfilled',
    semanticDementia: 'criteriaForNeuropathologicallyConfirmedDiagnosisForSemanticDementiaFulfilled',
    logopenicProgressiveAphasia:
      'criteriaForNeuropathologicallyConfirmedDiagnosisForLogopenicProgressiveAphasiaFulfilled',
  };

  const imagingCriteriaFulfilled = sections.filter(section => {
    const result = resultPicker(d, 'logopenicProgressiveAphasia', 'summary', imagingKeyMap[section]);
    return result === 'yes';
  });

  const neuropathologicalCriteriaFulfilled = sections.filter(section => {
    const result = resultPicker(d, 'logopenicProgressiveAphasia', 'summary', neuropathologicalKeyMap[section]);
    return result === 'yes';
  });

  const generalKeys = [
    'theFollowingThreeCharacteristicsShouldBePresentInTheSyndrome',
    'theFollowingFourCharacteristicsShouldNotBePresentInTheSyndrome',
  ];

  const generalCriteriaFulfilled =
    imagingCriteriaFulfilled.length > 0 || neuropathologicalCriteriaFulfilled.length > 0
      ? undefined
      : generalKeys.every(k => resultPicker(d, 'general', k) === 'yes')
        ? 'yes'
        : generalKeys.some(k => resultPicker(d, 'general', k) === 'no')
          ? 'no'
          : 'unknown';

  return (
    <React.Fragment>
      {imagingCriteriaFulfilled.length > 0 && (
        <div>
          <div>{fm('diagnosis.ppa.logopenicProgressiveAphasia.summary.imagingCriteriaFulfilled')}:</div>
          <span style={{ fontWeight: 400, whiteSpace: 'pre-line' }}>
            {imagingCriteriaFulfilled.map((r, i, arr) => (
              <span key={r}>
                {fm(`diagnosis.ppa.${r}.titleShort`)}
                {i < arr.length - 1 ? <br /> : null}
              </span>
            ))}
          </span>
        </div>
      )}
      {neuropathologicalCriteriaFulfilled.length > 0 && (
        <div>
          <div>{fm('diagnosis.ppa.logopenicProgressiveAphasia.summary.neuropathologicalCriteriaFulfilled')}:</div>
          <span style={{ fontWeight: 400, whiteSpace: 'pre-line' }}>
            {neuropathologicalCriteriaFulfilled.map((r, i, arr) => (
              <span key={r}>
                {fm(`diagnosis.ppa.${r}.titleShort`)}
                {i < arr.length - 1 ? <br /> : null}
              </span>
            ))}
          </span>
        </div>
      )}
      {generalCriteriaFulfilled &&
        fm(
          `diagnosis.ppa.logopenicProgressiveAphasia.summary.generalCriteria${generalCriteriaFulfilled ? '' : 'Not'}Fulfilled`,
        )}
    </React.Fragment>
  );
};

interface IOwnProps {
  d: IPPA;
}

export default PPADiagnosticCriteriaHistory;
